import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageSEO from './PageSEO';
import WordOfTheDay from './WordOfTheDay';

const GAMES = [
  {
    id: 'jumble',
    icon: '🔀',
    title: 'Jumble Solver',
    desc: 'Enter any mix of letters and find all valid words you can make — great for newspaper jumble puzzles!',
    path: '/jumble',
    color: '#7c3aed',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'unscramble',
    icon: '🔍',
    title: 'Word Unscrambler',
    desc: 'Got a scrambled word? Enter all the letters and instantly see every word they can form.',
    path: '/unscramble',
    color: '#0891b2',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'anagram-solver',
    icon: '🔤',
    title: 'Anagram Solver',
    desc: 'Find all valid anagrams hidden in any word or phrase. Discover surprising rearrangements!',
    path: '/anagram-solver',
    color: '#ea580c',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'anagram-generator',
    icon: '🎲',
    title: 'Anagram Generator',
    desc: 'Type a word and generate creative anagrams. Perfect for name puzzles and creative wordplay!',
    path: '/anagram-generator',
    color: '#0d9488',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'crossword',
    icon: '✏️',
    title: 'Crossword Solver',
    desc: 'Stuck on a crossword? Enter the pattern with _ for unknown letters (e.g. c_t) to find matches.',
    path: '/crossword',
    color: '#db2777',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'wordle-solver',
    icon: '💡',
    title: 'Wordle Solver',
    desc: 'Get smart suggestions for your Wordle game. Mark letters green, yellow, or gray to narrow it down.',
    path: '/wordle-solver',
    color: '#4f46e5',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'boggle',
    icon: '🎯',
    title: 'Boggle Solver',
    desc: 'Enter your 4×4 Boggle grid and instantly find every valid word hiding in the board!',
    path: '/boggle',
    color: '#65a30d',
    difficulty: 'hard',
    category: 'solver',
  },
  {
    id: 'scrabble',
    icon: '🃏',
    title: 'Scrabble Finder',
    desc: 'Enter your Scrabble tiles (use ? for blank) and get the highest-scoring words you can play.',
    path: '/scrabble',
    color: '#d97706',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'wordfeud-helper',
    icon: '🔠',
    title: 'Wordfeud Helper',
    desc: 'Enter your Wordfeud rack (use ? for blank) and find the top-scoring words — ranked by Wordfeud\'s own tile values.',
    path: '/wordfeud-helper',
    color: '#0ea5e9',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'word-ladder',
    icon: '🪜',
    title: 'Word Ladder Solver',
    desc: 'Transform one word into another by changing one letter at a time. Can you climb the word ladder?',
    path: '/word-ladder',
    color: '#e11d48',
    difficulty: 'hard',
    category: 'solver',
  },
  {
    id: 'rhyme',
    icon: '🎵',
    title: 'Rhyme Finder',
    desc: 'Enter any word and discover words that rhyme with it. Great for poetry and songwriting!',
    path: '/rhyme',
    color: '#7c3aed',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'palindrome',
    icon: '🔁',
    title: 'Palindrome Checker',
    desc: 'Check if a word or phrase reads the same forwards and backwards. A fun linguistic puzzle!',
    path: '/palindrome',
    color: '#059669',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'sudoku',
    icon: '🔢',
    title: 'Sudoku Solver',
    desc: 'Paste in any sudoku puzzle and watch it get solved instantly with our backtracking engine.',
    path: '/sudoku',
    color: '#1d4ed8',
    difficulty: 'hard',
    category: 'solver',
  },
  {
    id: 'wordle',
    icon: '🟩',
    title: 'Wordle Game',
    desc: 'Play the classic 5-letter word guessing game! You have 6 chances — green, yellow, gray!',
    path: '/wordle',
    color: '#16a34a',
    difficulty: 'medium',
    category: 'game',
  },
  {
    id: 'hangman',
    icon: '🎭',
    title: 'Hangman',
    desc: 'Guess the hidden word one letter at a time before the hangman is complete. Classic fun!',
    path: '/hangman',
    color: '#dc2626',
    difficulty: 'easy',
    category: 'game',
  },
  {
    id: 'word-search',
    icon: '🔎',
    title: 'Word Search',
    desc: 'Find hidden words in a letter grid! Words hide horizontally, vertically, and diagonally.',
    path: '/word-search',
    color: '#0284c7',
    difficulty: 'easy',
    category: 'game',
  },
  {
    id: 'spelling-bee',
    icon: '🐝',
    title: 'Spelling Bee Solver',
    desc: 'Enter 7 letters and a center letter — find every word that must include the center letter!',
    path: '/spelling-bee',
    color: '#d97706',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'longest-word',
    icon: '📏',
    title: 'Longest Word Finder',
    desc: 'Enter a bunch of letters and discover the longest English word you can possibly make!',
    path: '/longest-word',
    color: '#7c3aed',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'word-pattern',
    icon: '🔎',
    title: 'Word Pattern Finder',
    desc: 'Use ? for unknown letters. Type ?IGHT to find LIGHT, NIGHT, MIGHT and more instantly!',
    path: '/word-pattern',
    color: '#0891b2',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'scrabble-calculator',
    icon: '🧮',
    title: 'Scrabble Calculator',
    desc: 'Calculate the exact score for any Scrabble word including double and triple square bonuses!',
    path: '/scrabble-calculator',
    color: '#ea580c',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'pig-latin',
    icon: '🐷',
    title: 'Pig Latin Converter',
    desc: 'Convert any English text to Pig Latin instantly — or translate Pig Latin back to English!',
    path: '/pig-latin',
    color: '#db2777',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'word-scramble',
    icon: '⏱️',
    title: 'Word Scramble',
    desc: 'Race the clock! Unscramble a random word before 60 seconds run out and rack up points!',
    path: '/word-scramble',
    color: '#16a34a',
    difficulty: 'easy',
    category: 'game',
  },
  {
    id: 'word-chain',
    icon: '⛓️',
    title: 'Word Chain',
    desc: 'Each word must start with the last letter of the previous. How long can you keep the chain going?',
    path: '/word-chain',
    color: '#4f46e5',
    difficulty: 'medium',
    category: 'game',
  },
  {
    id: 'syllable-counter',
    icon: '🔢',
    title: 'Syllable Counter',
    desc: 'Count syllables in any word, sentence, or poem. Includes per-word breakdown and haiku checker.',
    path: '/syllable-counter',
    color: '#7c3aed',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'word-counter',
    icon: '📝',
    title: 'Word Counter',
    desc: 'Count words, characters, sentences, and paragraphs. Get reading time, speaking time, and keyword frequency.',
    path: '/word-counter',
    color: '#0891b2',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'cryptogram',
    icon: '🔐',
    title: 'Cryptogram Solver',
    desc: 'Decode substitution cipher puzzles by mapping each cipher letter to its real letter. Use frequency analysis to crack the code!',
    path: '/cryptogram',
    color: '#7c3aed',
    difficulty: 'medium',
    category: 'solver',
  },
  {
    id: 'morse-code',
    icon: '📡',
    title: 'Morse Code Converter',
    desc: 'Convert English text to Morse code or decode Morse back to text. Play the audio to hear real telegraph beeps!',
    path: '/morse-code',
    color: '#d97706',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'dordle',
    icon: '🟩🟩',
    title: 'Dordle',
    desc: 'Solve 2 Wordle puzzles at the same time! Each guess applies to both boards — 7 tries to crack them both.',
    path: '/dordle',
    color: '#059669',
    difficulty: 'hard',
    category: 'game',
  },
  {
    id: 'quordle',
    icon: '🟩🟩🟩🟩',
    title: 'Quordle',
    desc: 'The ultimate Wordle challenge — 4 words, 9 guesses. Every guess hits all 4 boards simultaneously. Can you do it?',
    path: '/quordle',
    color: '#4f46e5',
    difficulty: 'hard',
    category: 'game',
  },
  {
    id: 'connections',
    icon: '🔗',
    title: 'Connections',
    desc: 'Group 16 words into 4 secret categories. Yellow is straightforward, purple is fiendish. Find the hidden links!',
    path: '/connections',
    color: '#7c3aed',
    difficulty: 'hard',
    category: 'game',
  },
  {
    id: 'pangram-checker',
    icon: '🔤',
    title: 'Pangram Checker',
    desc: 'Check if your text uses all 26 letters of the alphabet. Watch the A–Z grid fill live, see missing letters, and explore 20 famous pangrams!',
    path: '/pangram-checker',
    color: '#0891b2',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'random-word-generator',
    icon: '🎲',
    title: 'Random Word Generator',
    desc: 'Generate random English words instantly. Filter by type, length, and starting letter. Save favorites, copy all, and share your list!',
    path: '/random-word-generator',
    color: '#0891b2',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'text-twist-solver',
    icon: '🔡',
    title: 'Text Twist Solver',
    desc: 'Enter your Text Twist letters and instantly find every word, grouped by length — longest words first. Never get stuck on a round again!',
    path: '/text-twist-solver',
    color: '#4f46e5',
    difficulty: 'easy',
    category: 'solver',
  },
  {
    id: 'word-twist',
    icon: '🔤',
    title: 'Word Twist',
    desc: 'Make as many words as you can from 6 scrambled letters in 2 minutes! Score points for 3, 4, 5, and 6-letter words. Find the WORD TWIST for a bonus!',
    path: '/word-twist',
    color: '#4f46e5',
    difficulty: 'medium',
    category: 'game',
  },
  {
    id: 'waffle',
    icon: '🧇',
    title: 'Waffle Word Game',
    desc: 'Swap tiles to spell 6 interlocking words in a waffle grid. Green locks in, yellow is close. Solve it in 15 swaps to earn 5 stars!',
    path: '/waffle',
    color: '#f59e0b',
    difficulty: 'hard',
    category: 'game',
  },
  {
    id: 'wordbloom',
    icon: '🌸',
    title: 'WordBloom',
    desc: 'Spell words from a blossom of 7 petals — every word must use the center letter. Hit the golden bonus petal and find pangrams to grow your score!',
    path: '/wordbloom',
    color: '#ec4899',
    difficulty: 'medium',
    category: 'game',
  },
  {
    id: 'letter-boxed',
    icon: '🔤',
    title: 'Letter Boxed',
    desc: 'Link the 12 letters around the box into words and use every side. Consecutive letters must switch sides — can you solve it in just 2 words?',
    path: '/letter-boxed',
    color: '#7c3aed',
    difficulty: 'hard',
    category: 'game',
  },
];

// Inline link style for the editorial "How to choose a game" section.
const LINK_STYLE = { color: 'var(--primary)', fontWeight: 700, textDecoration: 'none' };

const DIFF_LABELS = { easy: 'Easy', medium: 'Medium', hard: 'Hard' };
const DIFF_CLASS  = { easy: 'badge-easy', medium: 'badge-medium', hard: 'badge-hard' };
const CAT_LABELS  = { game: '🕹 Game', solver: '🔧 Solver' };
const CAT_CLASS   = { game: 'badge-game', solver: 'badge-solver' };

/* ============================================================================
 * Homepage long-form copy: intro paragraph + FAQ (also feeds the FAQPage schema).
 * ==========================================================================*/

const INTRO_COPY =
  'WordZingo is a free online home for word lovers, puzzlers, and curious minds of every age. ' +
  'Whether you want a quick round of Wordle on a coffee break, a tougher challenge like Waffle or ' +
  'Connections, or a little help getting unstuck on a stubborn crossword clue, you’ll find the right ' +
  'tool here. Our collection brings dozens of word games and instant solvers together in one clean, ' +
  'friendly place — no sign-ups, no downloads, and no clutter. Every solver is backed by a dictionary ' +
  'of more than 190,000 words, so the answers you get are thorough and trustworthy. And because ' +
  'WordZingo runs right in your browser, you can play on your phone, tablet, or computer whenever the ' +
  'mood strikes. Come for a single puzzle, stay to explore them all — and grow your vocabulary while ' +
  'you’re having fun.';

const FAQS = [
  {
    q: 'Is WordZingo really free to use?',
    a: 'Yes. Every game and solver on WordZingo is completely free, with no sign-up, no download, and no payment — ever.',
  },
  {
    q: 'Do I need to create an account?',
    a: 'No account is needed. Just open any game or solver and start playing or solving right away — nothing to register or install.',
  },
  {
    q: 'What’s the difference between a game and a solver?',
    a: 'Games are interactive puzzles you play for fun, like Wordle, Hangman, and Waffle. Solvers are tools that instantly answer or help with a puzzle — such as the Anagram Solver, Crossword Solver, or Scrabble Word Finder.',
  },
  {
    q: 'How big is the WordZingo dictionary?',
    a: 'Our solvers check every result against a dictionary of more than 190,000 words, so you can trust the answers are thorough and accurate.',
  },
  {
    q: 'Can I use WordZingo on my phone?',
    a: 'Absolutely. WordZingo works in any modern web browser on phones, tablets, and computers — there’s no app to download and nothing to update.',
  },
  {
    q: 'Is using a word solver cheating?',
    a: 'Not at all. Our solvers are learning and practice tools — people use them to discover new words, check an answer, settle a friendly debate, or get unstuck when a puzzle stalls. How you use them is entirely up to you.',
  },
];

// FAQPage structured data, built from FAQS so the schema and visible copy stay in sync.
const FAQ_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(f => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Home() {
  const [search, setSearch]     = useState('');
  const [filter, setFilter]     = useState('all');

  const filtered = GAMES.filter(g => {
    const matchSearch = g.title.toLowerCase().includes(search.toLowerCase()) ||
                        g.desc.toLowerCase().includes(search.toLowerCase());
    const matchFilter = filter === 'all' || g.category === filter;
    return matchSearch && matchFilter;
  }).sort((a, b) => a.title.localeCompare(b.title));

  return (
    <div>
      <PageSEO page="home" />
      {/* Hero */}
      <section className="hero-section">
        <div className="hero-badge">🆓 Free Forever · No Sign-up Required</div>
        <h1 className="hero-title">
          <span className="wz-hero-word">Word</span><span className="wz-hero-zingo">Zingo</span>
        </h1>
        <p className="hero-subtitle">Your ultimate word game destination</p>
        <p className="hero-sub2">Play free word games · Solve any word puzzle instantly</p>
        <div className="hero-stats">
          <div className="hero-stat"><strong>37</strong> Games &amp; Solvers</div>
          <div className="hero-stat-divider">·</div>
          <div className="hero-stat"><strong>190,000+</strong> Words</div>
          <div className="hero-stat-divider">·</div>
          <div className="hero-stat"><strong>100%</strong> Free</div>
        </div>
      </section>

      {/* Intro / About WordZingo — moved above the fold so real, crawlable
          content is visible immediately, not just the game grid. */}
      <section className="container-xl pt-4 pb-2" style={{ maxWidth: 900 }}>
        <h2 className="fw-bold mb-3">Free Word Games &amp; Puzzle Solvers, All in One Place</h2>
        <p style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.7 }}>{INTRO_COPY}</p>
      </section>

      {/* Word of the Day — daily-changing, prerendered content */}
      <WordOfTheDay />

      {/* Games Grid */}
      <section className="games-section">
        <div className="container-xl">
          <p className="games-search-label">🔍 Find Your Game or Solver</p>
          <div className="games-search">
            <i className="bi bi-search search-icon"></i>
            <input
              type="text"
              placeholder="Search 37+ games & solvers..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {/* Category Filter */}
          <div className="text-center" style={{ marginBottom: '1.5rem' }}>
            {[['all','🎮 All'],['game','🕹 Games'],['solver','🔧 Solvers']].map(([val, label]) => (
              <button
                key={val}
                onClick={() => setFilter(val)}
                className="btn btn-sm mx-1 fw-bold"
                style={{
                  borderRadius:'50px',
                  padding:'0.4rem 1.2rem',
                  background: filter === val ? 'var(--primary)' : 'transparent',
                  color: filter === val ? '#fff' : 'var(--muted)',
                  border: `2px solid ${filter === val ? 'var(--primary)' : 'var(--border)'}`,
                  fontFamily:'Nunito, sans-serif',
                  transition:'all 0.2s',
                }}
              >
                {label}
              </button>
            ))}
          </div>

          {filtered.length === 0 ? (
            <div className="text-center py-5">
              <div style={{fontSize:'3rem'}}>🤔</div>
              <p className="fw-bold text-muted mt-2">No games found for "{search}"</p>
            </div>
          ) : (
            <>
              <p className="text-muted fw-bold mb-3">{filtered.length} game{filtered.length !== 1 ? 's' : ''} found</p>
              <div className="row g-4">
                {filtered.map(game => (
                  <div key={game.id} className="col-12 col-sm-6 col-lg-4">
                    <div
                      className="game-card"
                      style={{'--card-color': game.color}}
                      onClick={() => window.location.href = game.path}
                    >
                      <div className="game-card-icon">{game.icon}</div>
                      <h3 className="game-card-title">{game.title}</h3>
                      <p className="game-card-desc">{game.desc}</p>
                      <div className="game-card-badges">
                        <span className={`game-card-badge ${CAT_CLASS[game.category]}`}>
                          {CAT_LABELS[game.category]}
                        </span>
                        {game.category === 'game' && (
                          <span className={`game-card-badge ${DIFF_CLASS[game.difficulty]}`}>
                            {DIFF_LABELS[game.difficulty]}
                          </span>
                        )}
                      </div>
                      <Link to={game.path} className="play-btn" style={{background: game.color}}>
                        {game.category === 'game' ? '▶ Play Now' : '🔍 Solve Now'}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Homepage long-form content (copy lives in INTRO_COPY and FAQS above). */}

      {/* How to choose a game — human-written editorial + internal links */}
      <section className="container-xl py-5" style={{ maxWidth: 900 }}>
        <h2 className="fw-bold mb-3">How to Choose the Right Word Game</h2>
        <p style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.7 }}>
          With more than 37 games and solvers here, it’s easy to feel spoiled for choice. The quickest
          way to decide is to ask yourself one simple question: <em>what am I actually in the mood for
          right now?</em> Here’s where we’d point you.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>
          🕐 “I’ve only got a couple of minutes”
        </h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Start with the classics. <Link to="/wordle" style={LINK_STYLE}>Wordle</Link> is the perfect
          coffee-break puzzle — one word, six guesses, done in three minutes. If you’d rather not think
          too hard, <Link to="/hangman" style={LINK_STYLE}>Hangman</Link> and{' '}
          <Link to="/word-search" style={LINK_STYLE}>Word Search</Link> are as relaxing as word games get.
          Want a jolt of adrenaline instead? <Link to="/word-scramble" style={LINK_STYLE}>Word Scramble</Link>{' '}
          puts 60 seconds on the clock and dares you to beat it.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>
          🧩 “I’m stuck on a puzzle and need a hand”
        </h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          This is what our solvers are for. Halfway through a crossword with a maddening blank?
          The <Link to="/crossword" style={LINK_STYLE}>Crossword Solver</Link> fills the gaps from a
          pattern like <code>c_t</code>. Staring at a scramble of letters? Feed them to the{' '}
          <Link to="/unscramble" style={LINK_STYLE}>Word Unscrambler</Link> or the{' '}
          <Link to="/anagram-solver" style={LINK_STYLE}>Anagram Solver</Link>. And if today’s Wordle is
          fighting back, the <Link to="/wordle-solver" style={LINK_STYLE}>Wordle Solver</Link> narrows the
          field the moment you mark your greens and yellows. Using a solver isn’t cheating — it’s the
          fastest way to learn words you didn’t know existed.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>
          🔥 “Give me a real challenge”
        </h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          If ordinary Wordle feels too easy now, level up to{' '}
          <Link to="/quordle" style={LINK_STYLE}>Quordle</Link> — four boards, nine guesses, every guess
          counts on all of them at once. <Link to="/waffle" style={LINK_STYLE}>Waffle</Link> and{' '}
          <Link to="/connections" style={LINK_STYLE}>Connections</Link> reward lateral thinking rather than
          raw vocabulary, and <Link to="/boggle" style={LINK_STYLE}>Boggle</Link> is a genuine test of how
          fast your brain can find hidden words in a grid.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>
          🎯 “I’m mid-game and need the best word”
        </h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Playing on a board? We’ve got a tool for your exact game. The{' '}
          <Link to="/scrabble" style={LINK_STYLE}>Scrabble Word Finder</Link> turns your rack into the
          highest-scoring play (and the{' '}
          <Link to="/scrabble-calculator" style={LINK_STYLE}>Scrabble Calculator</Link> tallies the points).
          Mid-round in Text Twist? The <Link to="/text-twist-solver" style={LINK_STYLE}>Text Twist Solver</Link>{' '}
          lists every word by length. Chasing today’s{' '}
          <Link to="/spelling-bee" style={LINK_STYLE}>Spelling Bee</Link> pangram? That one’s covered too.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>
          📚 “I want to build my vocabulary”
        </h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Some of our games double as quiet learning tools. <Link to="/wordbloom" style={LINK_STYLE}>WordBloom</Link>{' '}
          pushes you to find longer and rarer words from the same seven letters, while the{' '}
          <Link to="/rhyme" style={LINK_STYLE}>Rhyme Finder</Link> and{' '}
          <Link to="/syllable-counter" style={LINK_STYLE}>Syllable Counter</Link> are quietly indispensable
          for poetry and songwriting. Feeling curious? The{' '}
          <Link to="/random-word-generator" style={LINK_STYLE}>Random Word Generator</Link> is a fun way to
          stumble onto words you’ve never met.
        </p>

        <p className="mt-4" style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Still not sure? Use the search box at the top of the page to filter by name, or the{' '}
          <strong>Games / Solvers</strong> toggle to browse just the play-for-fun games or just the
          instant-answer tools. There’s no wrong place to start — pick one, and the rest will still be
          here when you’re done.
        </p>
      </section>

      {/* How our solvers work — plain-language explainer + internal links */}
      <section className="container-xl py-5" style={{ maxWidth: 900 }}>
        <h2 className="fw-bold mb-3">How Our Word Puzzle Solvers Work</h2>
        <p style={{ color: 'var(--muted)', fontSize: '1.05rem', lineHeight: 1.7 }}>
          A word solver does in a split second what would take you ages by hand: it looks at the letters
          you have and checks them against a giant list of real words to see what actually fits. Think of
          it as flipping through a 190,000-word dictionary instantly and pulling out every entry that
          matches — no guessing, no missed words, and nothing made up.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>You give it your letters</h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          You start by telling the solver what you’re working with — the jumbled letters from your puzzle,
          the tiles on your rack, or the clue pattern from a crossword. That’s the only step that needs you.
          If you don’t know a letter yet, most of our solvers let you leave a gap: type a{' '}
          <code>?</code> or an underscore where the missing letter goes, like <code>c_t</code>, and the
          solver treats it as “anything can go here.”
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>It checks every real word</h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Behind the scenes, the solver compares your letters against a trusted dictionary of more than
          190,000 words. It only keeps the words that can genuinely be built from what you gave it —
          so you never get nonsense or letters you don’t actually have. Because it checks the whole
          dictionary, it finds words you’d never spot on your own, including the sneaky short ones and the
          long, high-scoring ones.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>You get clean, sorted answers</h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Finally, the results are laid out so they’re easy to use — usually with the longest or
          highest-scoring words first, so the best play is right at the top. From there it’s up to you:
          pick the word you like, learn a new one, or just confirm the answer you already suspected.
        </p>

        <h3 className="fw-bold mt-4 mb-2" style={{ fontSize: '1.15rem' }}>Which solver should you use?</h3>
        <p style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          Each puzzle has a tool built for it. Here’s the quick version:
        </p>
        <ul style={{ color: 'var(--muted)', lineHeight: 1.9, fontSize: '1.02rem' }}>
          <li>A random jumble of letters → <Link to="/unscramble" style={LINK_STYLE}>Word Unscrambler</Link></li>
          <li>A crossword clue with blanks like <code>c_t</code> → <Link to="/crossword" style={LINK_STYLE}>Crossword Solver</Link></li>
          <li>Rearranging every letter of a word or phrase → <Link to="/anagram-solver" style={LINK_STYLE}>Anagram Solver</Link></li>
          <li>Stuck on today’s Wordle → <Link to="/wordle-solver" style={LINK_STYLE}>Wordle Solver</Link></li>
          <li>Your Scrabble tiles (blanks welcome) → <Link to="/scrabble" style={LINK_STYLE}>Scrabble Word Finder</Link></li>
          <li>Finding the longest possible word → <Link to="/longest-word" style={LINK_STYLE}>Longest Word Finder</Link></li>
        </ul>

        <p className="mt-2" style={{ color: 'var(--muted)', lineHeight: 1.7 }}>
          And no — using a solver isn’t cheating. It’s a practice and learning tool: a way to check an
          answer, settle a friendly argument, discover new words, or simply get unstuck when a puzzle
          stalls. How you use it is entirely your call.
        </p>
      </section>

      {/* FAQ + FAQPage JSON-LD */}
      <section className="container-xl py-5" style={{ maxWidth: 820 }}>
        <h2 className="fw-bold mb-4 text-center">Frequently Asked Questions</h2>
        {FAQS.map((f, i) => (
          <div key={i} className="mb-3"
               style={{ border: '2px solid var(--border)', borderRadius: 14, padding: '1rem 1.2rem', background: '#fff' }}>
            <h3 className="fw-bold mb-2" style={{ fontSize: '1.05rem' }}>{f.q}</h3>
            <p className="mb-0" style={{ color: 'var(--muted)', lineHeight: 1.6 }}>{f.a}</p>
          </div>
        ))}
        {/* FAQPage structured data for rich results (generated from FAQS) */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_SCHEMA) }} />
      </section>
    </div>
  );
}
